import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

/**
 * Extension of NGXLogger that automatically reports errors to Dynatrace.
 *
 * When error() is called:
 * 1. Logs to console/server via NGXLogger (parent class)
 * 2. Reports to Dynatrace via dtrum.reportError() API
 *
 * All other logger methods (info, debug, warn, etc.) work exactly as before.
 */
@Injectable({
  providedIn: 'root',
})
export class DynatraceLogger extends NGXLogger {
  override error(message: unknown, ...additional: unknown[]): void {
    // Call parent implementation (logs to console, server, etc.)
    super.error(message, ...additional);

    // Find Error object in arguments - check both message and additional params
    const allArgs = [message, ...additional];
    const errorObj = allArgs.find((arg): arg is Error => arg instanceof Error);

    // Report to Dynatrace if available
    if (errorObj && typeof window !== 'undefined' && window.dtrum) {
      try {
        window.dtrum.reportError(errorObj);
      } catch (dtrumError) {
        // If Dynatrace reporting fails, log it but don't break the app
        this.warn('Failed to report error to Dynatrace:', dtrumError);
      }
    }
  }
}
